import * as React from "react";
import { AccountRoleByActorDetails } from "../../../../../../Wrap/Models/Domains/Account/AccountRoleByActorDetails";
import { roleTypeMap } from "../../ClientRecord/Resource/Contents";

interface IRolesProps {
    rData: Array<AccountRoleByActorDetails>;
    otherrData: Array<AccountRoleByActorDetails>;
}
const renderRoles = (rData: Array<AccountRoleByActorDetails>, lengthDifference: number) => {
    const result = [];
    rData?.forEach((e) => {
        result.push(
            <p>
                {e?.ClAccountId} - {roleTypeMap[e?.AccountRoleType]}
            </p>
        );
    });
    if (lengthDifference > 0) {
        for (let i = 0; i < lengthDifference; i++) {
            result.push(<br />);
        }
    }

    return result;
};
export const Roles = (props: IRolesProps) => {
    let lengthDifference = 0;
    if (props.rData.length < props.otherrData.length) {
        lengthDifference = props.otherrData.length - props.rData.length;
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3>
                        <u>Roles</u>
                    </h3>
                </div>
            </div>
            {renderRoles(props?.rData, lengthDifference)}
        </>
    );
};
